import { Device, DeviceDAO } from "@app2u/notifications";

export class LocalStorageDeviceDAO implements DeviceDAO {
  DEVICE_ID_DB_KEY = "deviceId";
  DEVICE_SENT_DB_KEY = "deviceIdSent";

  notSentDevice(): Device | null {
    const deviceId = window.localStorage.getItem(this.DEVICE_ID_DB_KEY);
    if (deviceId == null) {
      return null;
    }
    const isSent =
      window.localStorage.getItem(this.DEVICE_SENT_DB_KEY) === "true";
    return isSent ? null : { identifier: deviceId };
  }

  create(deviceId: string): void {
    window.localStorage.setItem(this.DEVICE_ID_DB_KEY, deviceId);
    window.localStorage.setItem(this.DEVICE_SENT_DB_KEY, "false");
  }

  update(deviceId: string, isSent: boolean): void {
    window.localStorage.setItem(this.DEVICE_ID_DB_KEY, deviceId);
    window.localStorage.setItem(
      this.DEVICE_SENT_DB_KEY,
      isSent ? "true" : "false"
    );
  }

  exists(deviceId: string): boolean {
    const storedDeviceId = window.localStorage.getItem(this.DEVICE_ID_DB_KEY);
    return storedDeviceId === deviceId;
  }
}
